import React from "react"

import { Flex, Text, Divider } from "@mantine/core"

import { Icon } from "@/components/Icon"
import { useStyles } from "@/components/FormStepper/Step/Step.styles"

interface StepProps {
    label: string
    step: number
    isLastStep: boolean
    isConcluded: boolean
    isActive: boolean
    handleClick: (step: number) => void
    disabled?: boolean
}

export const Step = ({ isLastStep, label, step, isConcluded, isActive, handleClick, disabled }: StepProps) => {
    const { classes } = useStyles({ isActive, isConcluded, disabled })

    const stepNumber = step + 1

    return (
        <>
            <Flex
                className={classes.container}
                onClick={() => !disabled && handleClick(step)}
                data-testid="step__container"
                aria-disabled={disabled}
            >
                <Flex className={classes.step}>
                    {isConcluded ? <Icon icon="check" className={classes.checkIcon} /> : stepNumber}
                </Flex>
                <Text className={classes.label}>{label}</Text>
            </Flex>
            {!isLastStep && <Divider className={classes.divider} orientation="horizontal" />}
        </>
    )
}
